// extracted by mini-css-extract-plugin
module.exports = {"root":"user-story_root__l90oO","large":"user-story_large__O922t","medium":"user-story_medium__QUEKO","small":"user-story_small__zT48w","name":"user-story_name__6mXBO"};